import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { FormGroup, makeStyles } from "@material-ui/core";
import { Form, Formik } from "formik";
import { Search } from "@material-ui/icons";
import * as _ from "lodash";
import { Input, FormFeedback } from "reactstrap";
import AppColor from "utilities/AppColor";
import * as Yup from "yup";
import { useMedia } from "react-use";

const useStyles = makeStyles(() => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    borderRadius: "8px",
    border: props => `1px solid ${props.borderColor || AppColor.mainBlue}`,
  },
  input: {
    flex: 1,
    border: "none!important",
  },
  iconButton: {
    padding: 5,
    background: "transparent",
    border: "none",
    color: props => props.iconColor || props.borderColor || AppColor.mainBlue,
  },
}));

const InputSearch = (props) => {
  const {
    onSearch,
    onSearching = () => {},
    searchText,
    debounce = 500,
    placeholder,
  } = props;
  const { t } = useTranslation();
  const classes = useStyles(props);
  const below950 = useMedia('(max-width: 950px');

  const onSubmit = (data) => {
    const { search } = data;
    onSearch(search);
  };

  const debounceListener = _.debounce(onSearching, debounce);

  const validationSchema = Yup.object().shape({
    search: Yup.string().max(255, "validation.max_length_255").nullable(),
  });

  return (
    <Formik
      onSubmit={onSubmit}
      enableReinitialize={true}
      autoComplete={false}
      initialValues={{
        search: searchText || "",
      }}
      validationSchema={validationSchema}
    >
      {({ setFieldValue, errors, values }) => {
        return (
          <Form>
            <div className={classes.root} style={{ width: below950 ? '99%' : 'auto', ...props.style }}>
              <Input
                className={classes.input}
                placeholder={placeholder || t("label.search")}
                name="search"
                value={values.search}
                onChange={(event) => {
                  setFieldValue("search", event.target.value);
                  debounceListener(event.target.value);
                }}
              />
              <FormGroup>
                <button type="submit" className={classes.iconButton}>
                  <Search />
                </button>
              </FormGroup>
            </div>
            {errors.search && (
              <FormFeedback
                style={{
                  display: errors.search ? "inline" : "none",
                }}
              >
                {`${t(errors.search)}`}
              </FormFeedback>
            )}
          </Form>
        );
      }}
    </Formik>
  );
};

InputSearch.propTypes = {
  onSearch: PropTypes.func,
  searchText: PropTypes.string,
  onClear: PropTypes.func,
  onSearching: PropTypes.func,
  fullWidth: PropTypes.bool,
  debounce: PropTypes.number,
};

export default InputSearch;
